/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Button } from 'semantic-ui-react'
import OrderStore from '../OrderStore'
import { setBusyMode } from '../../../services/PointOfSale/PointOfSale.service'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@tanstack/react-query'
import useUser from '../../Shared/UserProvider/useUser'
import { isProviderACompany } from '../../../services/Provider/Provider.service'
import { useContext } from 'react'
import { UltyModalWrapperContext } from '../../Shared/UltyModalWrapper/UltyModalWrapperContext'
import { ultyToast } from '../../Shared/UltyToast/UltyToast'
import { BusyModeModal } from './BusyModeModal'

const ActivateBusyMode = () => {
    const [t] = useTranslation()
    const {user} = useUser()
    const {handleUltyModalWrapper} = useContext(UltyModalWrapperContext)
    const orderStore = OrderStore.useContainer()
    const updateBusyModeMutation = useMutation({
        mutationFn: ({ durationInMinutes }) => setBusyMode({status: orderStore.pausedAt ? 'IDLE' : 'BUSY', durationInMinutes}),
        onSuccess: (data) => {
            orderStore.setPausedAt(data.pausedAt)
            orderStore.setPausedUntil(data.pausedUntil)
        },
        onError: () => {
            ultyToast({ type: 'error', title: t('global.anErrorOccurred') })
        },
    })

    const defineModal = () => {
        const modalSettings = {
            size: 'tiny',
            closeIcon: undefined,
            component: (
              <BusyModeModal
                onDismiss={() => {
                    handleUltyModalWrapper(false, null)
                }}
                onValidate={({ durationInMinutes }) => {
                    updateBusyModeMutation.mutate({ durationInMinutes })
                    handleUltyModalWrapper(false, null)
                }}
              />
            ),
        }

        handleUltyModalWrapper(true, modalSettings)
    }

    const busyModeFinished = orderStore.pausedUntil && new Date(orderStore.pausedUntil) <= new Date()
    if (isProviderACompany(user?.provider) || (orderStore.pausedAt !== null && !busyModeFinished)) {
        return null
    }

    return (
      <div css={css`
          display: flex;
          justify-content: flex-end;
      `}>
          <Button
            css={css`
                &.ui.button {
                    margin: 0;
                }
            `}
            size="tiny"
            color="teal"
            basic
            onClick={defineModal}
            disabled={updateBusyModeMutation.isPending}
            loading={updateBusyModeMutation.isPending}>
              {t('navbar.busy_mode.activate_busy_mode')}
          </Button>
      </div>
    )
}

export default ActivateBusyMode
